
import { Component, Input, Output, EventEmitter, ViewChild, OnInit, OnChanges } from '@angular/core';
import {Router, ActivatedRoute} from "@angular/router";
import * as moment from 'moment';
import {getFiltersOffice} from '../../../../globals';

@Component({
  selector: 'services-search',
  templateUrl: '../../templates/partials/search-services.html'
})
export class SearchServicesComponent implements OnInit, OnChanges{

    public filterCity:Array<string> = [];
    public idInput:string;
    public unassigned: any = null;
    @Input() search;
    @Input() cleanFilter;
    @Output() filter = new EventEmitter();
    @Output() filterAssigned = new EventEmitter();
    public offices: Array<object>;
    public filterAllActive: boolean = false;
    public service = {
        serviceCode: null,
        userName: null,
        cleanerName: null,
        phoneContactPerson: null,
        emailContactPerson: null,
        address: null,
        dateIni: null,
        dateEnd: null,
    };

    constructor(private _router: Router){}

    
    public setFilterCity(city:string) {
        let isInArray = false;
        if(city == "all" || this.filterAllActive) {
            this.filterCity = [];
        }
        if(this.filterCity != null){
            for (var index = 0; index < this.filterCity.length; index++) {
                var element = this.filterCity[index];
                if(city == element){
                    isInArray = true;
                    this.filterCity.splice(index,1);
                    break;
                }
            }
        }
        if(this.filterAllActive && city == "all"){ 
            isInArray = true; 
        }
        if(!isInArray){
            this.filterCity.push(city);
        }
        if(!this.filterAllActive && city == "all") this.filterAllActive = true;
        else this.filterAllActive = false
        this.filterCity = this.filterCity.slice();
        this.filter.emit(this.filterCity);
    }

    public setOvalsActive(acronym: string) {
        
        if(this.filterCity != null && this.filterCity.length > 0){
            for (var index = 0; index < this.filterCity.length; index++) {
                var element = this.filterCity[index];
                if(acronym == element){ 
                    return 'c-oval--oval-active';
                }
            }
        }else return '';
    }

    public goNewService() {
        this._router.navigateByUrl('/new-service');
    }

    public filterByAssignment(event) {
        //console.log(this.unassigned);
        var data = (this.unassigned) ? 1 : null;
        this.filterAssigned.emit(data);
    }

    public emptyFilters(){
        this.filterCity = null;
        this.unassigned = null;
    }

    ngOnChanges(changes: any) {
        if(!changes.cleanFilter.firstChange){
            this.emptyFilters();
        }
    }


    ngOnInit() {
        this.offices = getFiltersOffice();
    }

}


// WEBPACK FOOTER //
// ./src/app/modules/assign/components/dummy/search-services.component.ts